import type {DocumentManager} from '@wix/document-manager-core'
import type {PossibleViewModes} from '@wix/document-services-types'
import {constants} from '@wix/document-manager-extensions'
import {handlers, HandlerResult} from './anomalyHandlers'
import {EMPTY_STRING, styles} from './consts'

const {TITLE_STYLE} = styles
const {VIEW_MODES} = constants

const printHandlerResult = (result: HandlerResult) => {
    if (result.content === EMPTY_STRING) return
    console.log(`%c${result.title}: `, TITLE_STYLE)
    console.log(`%c${result.content}`, result.style)
}

export const anomalyTool = ({extensionAPI, dal, pointers}: DocumentManager) => {
    const get = (viewModes: PossibleViewModes[]) => {
        const {generalSiteHandlers, viewModeSiteHandlers} = handlers(extensionAPI, dal, pointers)
        Object.values(generalSiteHandlers).forEach(handler => {
            printHandlerResult(handler())
        })
        viewModes.forEach(viewMode =>
            Object.values(viewModeSiteHandlers).forEach(handler => {
                printHandlerResult(handler(viewMode))
            })
        )
    }

    return {
        report: {
            mobile: {
                get: () => get([VIEW_MODES.MOBILE])
            },
            desktop: {
                get: () => get([VIEW_MODES.DESKTOP])
            },
            get: () => get(Object.values(VIEW_MODES))
        }
    }
}
